module.exports = __webpack_public_path__ + "static/media/sign-up.8c0e6c35.png";